import React, { useContext, useEffect, useState } from "react"; // Add useState
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

// alphabetized
import * as yup from "yup";
import qapi from "views_shared/app/javascript/api";
import SaveSpinnerButton from "./save_spinner_button";
import companySchema from "../../../yup_schemas/company_schema";
import { CompanyContext } from "../data/company_context_management";

function LinkedinUrlForm() {
  const context = useContext(CompanyContext);

  const { company, isUpdating, setIsUpdating, setDoTopLevelFetch } = context;

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    setError,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(
      yup.object().shape({
        linkedin_url: companySchema.fields.linkedin_url,
      }),
    ),
  });

  const urlContactInfo = company.contact_details?.find((detail) => detail.type === "linkedin") || {};
  const url = urlContactInfo.value;

  // Watch the linkedin_url value
  const watchedLinkedinUrl = watch("linkedin_url");

  // State to manage whether the Save button is enabled
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);

  useEffect(() => {
    setValue("linkedin_url", url);
    setIsSaveEnabled(false); // Reset when the component is reloaded
  }, [company, setValue, url]);

  useEffect(() => {
    // Enable the Save button if the watched value is different from the initial value
    setIsSaveEnabled(watchedLinkedinUrl !== url);
  }, [watchedLinkedinUrl, url]);

  const onSubmit = async (data, event) => {
    event.preventDefault();
    setIsUpdating(true);

    const { linkedin_url: linkedinUrl } = data;

    let response;

    const contactInfoId = urlContactInfo.contact_info_id;
    if (contactInfoId) {
      if (linkedinUrl.length === 0) {
        response = await qapi.contactInfos.deleteById(contactInfoId);
      } else {
        response = await qapi.contactInfos.updateById(contactInfoId, { value: linkedinUrl });
      }
    } else {
      response = await qapi.contactInfos.createByContactOwner(company.id, "Id::PromoEntity::Company", {
        value: linkedinUrl,
        value_type: "linkedin",
      });
    }

    if (response.error) {
      const error = response.error?.body?.errors[0];
      setError("linkedin_url", {
        type: "manual",
        message: error?.detail || "An error occurred",
      });
    } else {
      setDoTopLevelFetch(true);
      setIsSaveEnabled(false);
    }

    setIsUpdating(false);
  };

  return (
    // Top-aligned on purpose: centering re-centers the whole row when the validation message
    // appears, visibly shoving the field upward. Top alignment keeps label, field, and Save in
    // place and lets the message extend downward.
    <form onSubmit={(e) => e.preventDefault()} className="row g-2 align-items-start mb-2">
      <label htmlFor="linkedin_url" className="col-sm-3 col-form-label">
        LinkedIn URL
      </label>
      <div className="col">
        <input
          className={`form-control ${errors?.linkedin_url ? "is-invalid" : ""}`}
          defaultValue={url}
          id="linkedin_url"
          pattern="https://.*"
          placeholder="https://www.linkedin.com/example"
          type="url"
          required
          {...register("linkedin_url")}
        />
        {errors?.linkedin_url && <div className="invalid-feedback">{errors?.linkedin_url?.message}</div>}
      </div>
      <div className="col-auto">
        <SaveSpinnerButton
          activeText="Saving..."
          className={`${!isSaveEnabled ? "disabled" : ""}`}
          disabled={!isSaveEnabled}
          id="linkedin-url-save"
          inactiveText="Save"
          isSaving={isUpdating}
          onClick={handleSubmit(onSubmit)}
        />
      </div>
    </form>
  );
}

export default LinkedinUrlForm;
